// extracted by mini-css-extract-plugin
export default {"role":"_1i97H","roleName":"VvrYH"};